import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CircleIcon from '@mui/icons-material/Circle'
import capitalizeFirstWord from 'services/helper/capitalizeFirstWord'

const RequestSucess = ({ value, index, data, match_sm, match_mobile_m, navigate, location }) => {
  return (
    <Box
      component={'div'}
      sx={{
        px: '14px',
        py: '16px',
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'primary.light',
        },
        borderRadius:
          data.length === 1
            ? '10px'
            : index === 0
            ? '10px 10px 0 0'
            : index === data?.length - 1
            ? '0 0 10px 10px'
            : '',
        border: 1,
        borderTop: index === 0 ? 1 : 0,
        borderBottom: index === data?.length - 1 ? '' : 1,
        borderColor: 'grayscale.line-light',
      }}
      onClick={() =>
        navigate(
          value.type === 'claim' ? `/app/claim/reports/${value.id}` : '/app/leave/request/overview',
          {
            state: {
              leave_type: value.leave_type,
              from: 'dashboard',
              id: value.id,
              currentLocation: location.pathname,
            },
          }
        )
      }
    >
      <Box sx={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
        <Box
          sx={{
            width: 46,
            height: 46,
            minWidth: 46,
            minHeight: 46,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '100%',
            backgroundColor: 'alternate.light',
            color: 'alternate.main',
          }}
        >
          {value.type === 'leave' ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M20 3h-1V2c0-.55-.45-1-1-1s-1 .45-1 1v1H7V2c0-.55-.45-1-1-1s-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-1 18H5c-.55 0-1-.45-1-1V8h16v12c0 .55-.45 1-1 1"
              />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <g fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M7.5 5.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205q1.399.128 2.774.334c1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.7 24.7 0 0 1 12 15.75a24.7 24.7 0 0 1-7.814-1.259c-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A49 49 0 0 1 7.5 5.455zm7.5 0v.09a50 50 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5m-3 8.25a.75.75 0 1 0 0-1.5a.75.75 0 0 0 0 1.5"
                  clipRule="evenodd"
                />
                <path d="M3 18.4v-2.796a4.3 4.3 0 0 0 .713.31A26.2 26.2 0 0 0 12 17.25c2.892 0 5.68-.468 8.287-1.335q.378-.127.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923c-2.12.282-4.282.427-6.477.427a49 49 0 0 1-6.477-.427C4.047 21.128 3 19.852 3 18.4" />
              </g>
            </svg>
          )}
        </Box>
        <Box display={'flex'} flexDirection={'column'} gap={1}>
          <Typography variant="subtitle1" color={'#4A4A4A'}>
            {capitalizeFirstWord(value.title)}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'start', sm: 'center' },
              gap: 1,
            }}
          >
            <Typography variant="subtitle2" color={'alternate.main'}>
              {match_sm
                ? value.type === 'claim'
                  ? value.claim_report_type
                  : `${value.amount} day(s)`
                : value.type === 'claim'
                ? `RM ${value.amount}`
                : `${value.amount}  day(s)`}
            </Typography>
            {match_mobile_m && (
              <>
                <CircleIcon
                  sx={{
                    fontSize: '5px',
                    color: '#8D9593',
                    display: { xs: 'none', sm: 'block' },
                  }}
                />
                <Typography variant="body2" color={'#8D9593'}>
                  {value.start_date} - {value.end_date}
                </Typography>
              </>
            )}
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {value.type === 'claim' && (
          <Typography
            variant="subtitle1"
            color={'dark-text.main'}
            sx={{ mr: '14px', display: { xs: 'none', sm: 'initial' } }}
          >
            RM {value.amount}
          </Typography>
        )}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="16"
          viewBox="0 0 8 16"
          fill="none"
        >
          <path
            d="M1.32922 7.85718e-05C1.49994 -0.000502201 1.66862 0.0371765 1.82287 0.110345C1.97711 0.183514 2.11301 0.290314 2.22056 0.422897L7.74004 7.27939C7.90812 7.48387 8 7.74035 8 8.00504C8 8.26973 7.90812 8.52621 7.74004 8.73068L2.02629 15.5872C1.83232 15.8205 1.55359 15.9673 1.25142 15.9952C0.949248 16.023 0.648384 15.9297 0.415015 15.7357C0.181647 15.5418 0.0348907 15.263 0.00703058 14.9609C-0.0208291 14.6587 0.0724894 14.3578 0.266458 14.1245L5.37455 7.99932L0.437872 1.87419C0.298133 1.70645 0.209368 1.50219 0.182079 1.28559C0.154791 1.06898 0.190122 0.849087 0.283891 0.651931C0.37766 0.454775 0.525943 0.288606 0.711194 0.173086C0.896446 0.0575651 1.11091 -0.00247253 1.32922 7.85718e-05Z"
            fill="#8D9593"
          />
        </svg>
      </Box>
    </Box>
  )
}

export default RequestSucess
